import { useContext, useEffect, useMemo, useState } from 'react'

import contextData from '../contextData'

const OTHER_REFERRAL_SOURCE_KEY = 'Other'

const ReferralSourceHooks = (currentIndex: number) => {
  const { moduleList, dataCollect, mergeDataCollectFunction } = useContext(contextData)
  const currentData = moduleList[currentIndex]
  const referralSource = (useMemo(() => dataCollect?.[currentIndex]?.submitValue?.[0]?.value, [currentIndex, dataCollect]) as string) || ''
  const referralSourceOptions = useMemo(() => currentData?.question?.referralSource || [], [currentData])
  const isPresetReferralSource = useMemo(
    () => referralSourceOptions.some((item: { key: string }) => item?.key === referralSource),
    [referralSourceOptions, referralSource],
  )
  const [otherReferralSource, setOtherReferralSource] = useState(!isPresetReferralSource && referralSource ? referralSource : '')
  const selectedReferralSource = useMemo(() => {
    if (!referralSource) return ''
    if (referralSource === OTHER_REFERRAL_SOURCE_KEY) return OTHER_REFERRAL_SOURCE_KEY
    if (!isPresetReferralSource) return OTHER_REFERRAL_SOURCE_KEY
    return referralSource
  }, [isPresetReferralSource, referralSource])
  const isOtherSelected = useMemo(() => selectedReferralSource === OTHER_REFERRAL_SOURCE_KEY, [selectedReferralSource])
  const trimmedOtherReferralSource = useMemo(() => otherReferralSource.trim(), [otherReferralSource])
  const isCanNext = useMemo(() => {
    if (isOtherSelected) return Boolean(trimmedOtherReferralSource)
    return Boolean(selectedReferralSource)
  }, [isOtherSelected, selectedReferralSource, trimmedOtherReferralSource])

  const displayData = useMemo(() => {
    if (isOtherSelected) return trimmedOtherReferralSource
    return referralSourceOptions.find((item: { key: string }) => item?.key === selectedReferralSource)?.desc || ''
  }, [isOtherSelected, referralSourceOptions, selectedReferralSource, trimmedOtherReferralSource])

  const onReferralSourceChange = (value: string) => {
    const submitValue = [
      {
        name: dataCollect[currentIndex]?.submitValue?.[0].name,
        value: value === OTHER_REFERRAL_SOURCE_KEY ? trimmedOtherReferralSource || OTHER_REFERRAL_SOURCE_KEY : value || null,
      },
    ]
    if (mergeDataCollectFunction) {
      mergeDataCollectFunction(currentIndex, { submitValue })
    }
  }

  const onOtherReferralSourceChange = (value: string) => {
    setOtherReferralSource(value)
    const submitValue = [{ name: dataCollect[currentIndex]?.submitValue?.[0].name, value: value.trim() || OTHER_REFERRAL_SOURCE_KEY }]
    if (mergeDataCollectFunction) {
      mergeDataCollectFunction(currentIndex, { submitValue })
    }
  }

  useEffect(() => {
    if (!referralSource) {
      setOtherReferralSource('')
      return
    }
    if (!isPresetReferralSource && referralSource !== OTHER_REFERRAL_SOURCE_KEY) {
      setOtherReferralSource(referralSource)
    }
  }, [isPresetReferralSource, referralSource])

  useEffect(() => {
    if (mergeDataCollectFunction) {
      mergeDataCollectFunction(currentIndex, {
        isCanNext,
        displayData,
      })
    }
  }, [isCanNext, displayData])

  return {
    currentData,
    referralSource,
    selectedReferralSource,
    isOtherSelected,
    otherReferralSource,
    onReferralSourceChange,
    onOtherReferralSourceChange,
  }
}

export default ReferralSourceHooks
